import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import EmployeeComp from './EmployeeComp' 

function Employees() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <EmployeeComp/>      
        </div>
    </div>
  )
}

export default Employees